import { FaqSection } from '@cinch-nx/data-storyblok'
import { Wrapper } from '@cinch-nx/shared-ui'

import { supportContactContent } from '../../data/content'
import SupportAddress from '../address/support-address'
import Complaints from '../complaints/complaints'
import ContactCard from '../contact-card/contact-card'
import SupportFaqs from '../faqs/support-faqs'
import SupportPreFooter from '../pre-footer/support-pre-footer'
import styles from './help-and-support.module.css'

export const callUsPhoneNumberDigits = (str: string) => str.replace(/\D/g, '')

export interface HelpAndSupportProps {
  faqs: FaqSection[]
}

const HelpAndSupport = ({ faqs }: HelpAndSupportProps) => {
  const {
    whatsAppHeading,
    whatsAppHref,
    smsHref,
    whatsAppBody,
    whatsAppCta,
    textHeading,
    textBody,
    textCta,
    emailHeading,
    emailBody,
    emailCta,
    emailHref,
    callHeading,
    callBody,
    callCta,
  } = supportContactContent

  return (
    <>
      <Wrapper>
        <h2 className={styles.title}>Help and support</h2>
        <div className={styles.panels}>
          <ContactCard
            svgType="whatsapp"
            heading={whatsAppHeading}
            body={whatsAppBody}
            cta={whatsAppCta}
            category={'whatsApp'}
            href={whatsAppHref}
            shouldHideOnDesktop={true}
          />

          <ContactCard
            svgType="smartphone"
            heading={textHeading}
            body={textBody}
            cta={textCta}
            href={smsHref}
            category={'text'}
            shouldHideOnDesktop={true}
          />

          <ContactCard
            svgType="mail"
            heading={emailHeading}
            body={emailBody}
            cta={emailCta}
            href={emailHref}
            category={'email'}
          />

          <ContactCard
            svgType="phone"
            heading={callHeading}
            body={callBody}
            cta={callUsPhoneNumberDigits(callCta)}
            href={`tel:${callCta}`}
            category={'phone'}
          />
        </div>
        <Complaints />
        <div className={styles.faqWrapper}>
          <SupportFaqs faqs={faqs} />
        </div>
        <SupportAddress />
      </Wrapper>
      <SupportPreFooter />
    </>
  )
}

export default HelpAndSupport
